import { Check, Sunrise, Utensils } from "lucide-react";
import CTAButton from "@/components/CTAButton";
import { formatPrice, includesBreakfast, includesLunch } from "@/lib/plans";

export const PlanCard = ({ plan, compact = false }) => (
  <article
    data-testid={`plan-card-${plan.id}`}
    className={`mbm-card mbm-card-hover flex flex-col p-6 sm:p-8 ${
      plan.featured ? "bg-sageSoft" : ""
    }`}
  >
    <div className="flex items-start justify-between gap-3">
      <div>
        <p className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-cocoa/70">
          {plan.durationLabel} · {plan.weeks === 1 ? "1 week" : `${plan.weeks} weeks`}
        </p>
        <h3 className="mt-1.5 font-heading text-2xl font-black tracking-[-0.02em]">{plan.typeLabel}</h3>
      </div>
      {plan.badge && (
        <span className="shrink-0 rounded-full bg-coralInk px-3.5 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.1em] text-white">
          {plan.badge}
        </span>
      )}
    </div>

    <p className="mt-3 text-sm font-medium leading-relaxed text-cocoa/80">{plan.summary}</p>

    <div className="mt-5 flex flex-wrap gap-2">
      {includesBreakfast(plan) && (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-sage px-3.5 py-1.5 text-[12px] font-bold text-cocoa">
          <Sunrise className="h-3.5 w-3.5" aria-hidden="true" /> Breakfast
        </span>
      )}
      {includesLunch(plan) && (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-sage px-3.5 py-1.5 text-[12px] font-bold text-cocoa">
          <Utensils className="h-3.5 w-3.5" aria-hidden="true" /> Lunch
        </span>
      )}
      <span className="mbm-chip">{plan.totalMeals} meals</span>
    </div>

    <div className="mt-5 rounded-[22px] bg-sageSoft px-5 py-4">
      <p className="font-heading text-xl font-black text-cocoa">
        {formatPrice(plan)}
        {plan.price && (
          <span className="ml-1 text-sm font-bold text-cocoa/75">/ {plan.cadence}</span>
        )}
      </p>
      <p className="mt-1.5 text-xs font-medium leading-relaxed text-cocoa/70">{plan.priceNote}</p>
      <p className="mt-1 text-xs text-cocoa/75">
        {plan.deliveryFee
          ? `Delivery ₹${plan.deliveryFee}`
          : "Delivery fee confirmed at checkout"}
      </p>
    </div>

    {!compact && (
      <ul className="mt-6 flex-1 space-y-3">
        {plan.features.map((f) => (
          <li key={f} className="flex gap-2.5 text-sm font-medium text-cocoa/70">
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-coralInk" aria-hidden="true" />
            {f}
          </li>
        ))}
      </ul>
    )}

    <p className="mt-5 text-xs font-medium text-cocoa/75">{plan.renewal}</p>

    <CTAButton
      to={`/checkout?plan=${plan.id}`}
      variant={plan.featured ? "primary" : "secondary"}
      className="mt-6 w-full"
      data-testid={`plan-cta-${plan.id}`}
    >
      {plan.cta}
    </CTAButton>
  </article>
);

export default PlanCard;
